
import Vue from 'vue';
import BravadoTheme from '@/components/common/BravadoTheme/BravadoTheme.vue';
import Careers from '@/components/partials/landings/careers/Careers.vue';

export default Vue.extend({
  name: 'CareersPage',
  components: {
    Careers,
    BravadoTheme,
  },
  layout: 'clear',
  // @ts-ignore
  colorMode: 'light',
  head() {
    return this.$seo({
      title: 'Career in Bravado',
      description:
        'Bravado is dedicated to helping salespeople build the careers they deserve. We’re expanding our team rapidly to meet unprecedented demand across the entire sales community. We’re on a big mission, and we need your help to get it done.',
    });
  },
});
